import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('ata_token'));
  const [loading, setLoading] = useState(true);

  const validateToken = useCallback(async () => {
    const storedToken = localStorage.getItem('ata_token');
    if (!storedToken) {
      setLoading(false);
      return;
    }

    try {
      const data = await api.get('/auth/me');
      setUser(data.user);
      setToken(storedToken);
    } catch {
      localStorage.removeItem('ata_token');
      localStorage.removeItem('ata_user');
      setUser(null);
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    validateToken();
  }, [validateToken]);

  const login = async (username, password, portal) => {
    const endpoint =
      portal === 'dio' ? '/auth/dio/login' : '/auth/team/login';

    const data = await api.post(endpoint, { username, password });

    localStorage.setItem('ata_token', data.token);
    localStorage.setItem('ata_user', JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);

    return data;
  };

  const logout = () => {
    localStorage.removeItem('ata_token');
    localStorage.removeItem('ata_user');
    setToken(null);
    setUser(null);
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated: !!user && !!token,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export default AuthContext;
